import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appValidatePastedSpecialCharacter]',
    standalone: false
})
export class RegexPasteDirective {

    @HostListener('paste', ['$event'])

    clickEvent(e: ClipboardEvent) {
      this.validateFields(e);
    }

    validateFields(event: ClipboardEvent){
      event.preventDefault();
      const pasteData = event.clipboardData.getData('text/plain').replace(/[^a-zA-Z0-9-.,?!:;'/"//()\r\n ]/g, '',);
      document.execCommand('insertHTML', false, pasteData);
    }
}
